
export default function About() {
  return (
    <section id="about" className="bg-gradient-to-b from-stone-200 to-stone-100 py-12 md:py-16 lg:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
        {/* Left - Image */}
        <div className="relative order-2 lg:order-1">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/a57c62b74dcb42038fe4a9c3b70f4ee4.jpg"
              alt="SkyForge ASU Infrastructure"
              className="w-full h-[280px] md:h-[350px] lg:h-[420px] object-cover object-top"
            />
          </div>

          {/* Floating Infrastructure Metrics */}
          <div className="absolute -bottom-4 md:-bottom-6 left-3 right-3 md:left-6 md:right-6 flex gap-2 md:gap-3">
            <div className="flex-1 bg-stone-50 border border-stone-200 rounded-xl p-2.5 md:p-4 shadow-lg">
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-global-line text-base md:text-lg text-teal-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-xs md:text-sm">4 Regions</p>
                  <p className="text-stone-500 text-[10px] md:text-xs">Global Deployment</p>
                </div>
              </div>
            </div>
            <div className="flex-1 bg-stone-50 border border-stone-200 rounded-xl p-2.5 md:p-4 shadow-lg">
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-cyan-100 rounded-lg flex items-center justify-center">
                  <i className="ri-building-4-line text-base md:text-lg text-cyan-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-xs md:text-sm">5+ ASUs</p>
                  <p className="text-stone-500 text-[10px] md:text-xs">Production Sites</p>
                </div>
              </div>
            </div>
            <div className="flex-1 bg-stone-50 border border-stone-200 rounded-xl p-2.5 md:p-4 shadow-lg">
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-ship-line text-base md:text-lg text-teal-600"></i>
                </div>
                <div>
                  <p className="text-stone-800 font-bold text-xs md:text-sm">AI Ports</p>
                  <p className="text-stone-500 text-[10px] md:text-xs">Smart Logistics</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Content */}
        <div className="order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-4 md:mb-5">
            <div className="w-8 md:w-10 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full"></div>
            <span className="text-teal-600 text-xs md:text-sm font-bold tracking-wide uppercase">
              Global Infrastructure
            </span>
          </div>

          <h2 className="text-stone-800 font-black text-2xl md:text-3xl lg:text-4xl leading-tight mb-4 md:mb-5">
            Multi-Region
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500">
              Infrastructure Deployment
            </span>
          </h2>

          <p className="text-stone-600 text-sm md:text-base leading-relaxed mb-4 md:mb-5">
            SkyForge is executing a multi-region infrastructure rollout combining industrial gas production, cryogenic logistics, port automation, and AI-powered supply chain intelligence across strategic global trade corridors.
          </p>

          <p className="text-stone-600 text-sm md:text-base leading-relaxed mb-6 md:mb-8">
            From U.S. logistics corridors to international port systems, our integrated approach delivers foundational infrastructure powering industry, healthcare, aerospace, and energy sectors worldwide.
          </p>

          {/* Infrastructure Deployment Pillars */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-teal-200 rounded-xl p-4 md:p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-10 h-10 md:w-11 md:h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-2 md:mb-3 shadow-sm">
                <i className="ri-building-4-line text-lg md:text-xl text-teal-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">ASU Deployment</p>
              <p className="text-stone-500 text-xs">
                Air Separation Units for LOX, LIN, LAR production
              </p>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-cyan-200 rounded-xl p-4 md:p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-10 h-10 md:w-11 md:h-11 bg-cyan-100 rounded-lg flex items-center justify-center mb-2 md:mb-3 shadow-sm">
                <i className="ri-snowflake-line text-lg md:text-xl text-cyan-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">Cryogenic Logistics</p>
              <p className="text-stone-500 text-xs">
                Advanced storage and distribution networks
              </p>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-stone-200 rounded-xl p-4 md:p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-10 h-10 md:w-11 md:h-11 bg-stone-200 rounded-lg flex items-center justify-center mb-2 md:mb-3 shadow-sm">
                <i className="ri-ship-line text-lg md:text-xl text-teal-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">Port Automation</p>
              <p className="text-stone-500 text-xs">
                Smart port integration and maritime fueling
              </p>
            </div>

            <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-stone-200 rounded-xl p-4 md:p-5 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-10 h-10 md:w-11 md:h-11 bg-stone-200 rounded-lg flex items-center justify-center mb-2 md:mb-3 shadow-sm">
                <i className="ri-cpu-line text-lg md:text-xl text-cyan-600"></i>
              </div>
              <p className="text-stone-800 font-bold text-sm mb-1">AI Supply Chain</p>
              <p className="text-stone-500 text-xs">
                Intelligent logistics and demand forecasting
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
